import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "action-bar" }
const _hoisted_2 = {
  key: 0,
  class: "variable-picker"
}
const _hoisted_3 = { class: "emoji-picker-and-icon" }

import { InputVariableViewModel } from '@/features/bots/models/designer';
import EmojiIcon from 'vue-material-design-icons/EmoticonHappyOutline.vue';
import EmojiPicker from '@/features/bots/components/designer/TextEditor/EmojiPicker.vue';
import VariablePicker from '@/features/bots/components/designer/VariablePicker/VariablePicker.vue';
import CodeIcon from 'vue-material-design-icons/CodeBrackets.vue';
import { useStore } from 'vuex';
import { computed, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ActionBar',
  props: {
  showVariablePicker: {
    type: Boolean,
    default: true,
  },
},
  emits: ["addVariable", "addEmoji"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const store = useStore();
const flowVariables = computed<InputVariableViewModel[]>(() => store.getters.flowVariables);

const isVariablePickerOpen = ref(false);
const isEmojiPickerOpen = ref(false);

function addVariableToText(variable: InputVariableViewModel) {
  isVariablePickerOpen.value = false;
  emit('addVariable', variable);
}

function insertEmoji(emoji: any) {
  closeEmojiPicker();
  emit('addEmoji', emoji.native);
}

function closeEmojiPicker() {
  isEmojiPickerOpen.value = false;
}

function toggleEmojiPicker() {
  isEmojiPickerOpen.value = !isEmojiPickerOpen.value;
  if (isEmojiPickerOpen.value) {
    isVariablePickerOpen.value = false;
  }
}

function closeVariablePicker() {
  isVariablePickerOpen.value = false;
}

function getNameAttributes(): InputVariableViewModel[] {
  const firstName = {
    key: 'givenName',
    id: 'givenName',
    scope: 'appUser',
    dataType: 'text',
    name: 'First Name',
  } as InputVariableViewModel;

  const secondName = {
    key: 'surname',
    id: 'surname',
    scope: 'appUser',
    dataType: 'text',
    name: 'Last Name',
  } as InputVariableViewModel;

  return [firstName, secondName];
}

return (_ctx: any,_cache: any) => {
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.showVariablePicker)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(CodeIcon, {
            class: _normalizeClass(["icon-1-2x action-icon code-icon", { clicked: isVariablePickerOpen.value }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isVariablePickerOpen.value = !isVariablePickerOpen.value))
          }, null, 8, ["class"]),
          _createVNode(VariablePicker, {
            class: "dropdown-trigger",
            direction: "left",
            readonly: true,
            open: isVariablePickerOpen.value,
            showButton: false,
            onVariableSelected: addVariableToText,
            "additional-attributes": getNameAttributes()
          }, null, 8, ["open", "additional-attributes"])
        ])), [
          [_directive_click_away, closeVariablePicker]
        ])
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createVNode(EmojiIcon, {
        class: _normalizeClass(["icon-1-2x emoji-icon action-icon", { clicked: isEmojiPickerOpen.value }]),
        onClick: toggleEmojiPicker
      }, null, 8, ["class"]),
      _createVNode(EmojiPicker, {
        onInsertEmoji: insertEmoji,
        show: isEmojiPickerOpen.value
      }, null, 8, ["show"])
    ])), [
      [_directive_click_away, closeEmojiPicker]
    ])
  ]))
}
}

})